module.exports = __webpack_public_path__ + "static/media/play-store.841980b8.png";